import RegisterForm from "../components/auth/register/RegisterForm";

function Register() {
	return (
		<section>
			<RegisterForm />
		</section>
	);
}

export default Register;
